import { render } from "./cp_compare.vue?vue&type=template&id=8c753fb4&scoped=true"
import script from "./cp_compare.vue?vue&type=script&lang=js"
export * from "./cp_compare.vue?vue&type=script&lang=js"

import "./cp_compare.vue?vue&type=style&index=0&id=8c753fb4&scoped=scoped&lang=less"

import exportComponent from "E:\\Project\\HZY\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c753fb4"]])

export default __exports__